import React from 'react'
import { connect } from 'react-redux'
import { maximizeModal } from './redux/GlobalModalActions'

const ModalTabBar = ({ modal, maximizeModal }) => {
  return (
    <>
      {Object.values(modal).map((mod) => {
        if (mod.type === 'minimized') {
          return (
            <div key={mod.id} onKeyDown={() => {}} onClick={() => maximizeModal(mod.id)} className='minimizedTab'>
              {mod.name}
            </div>
          )
        }
        return
      })}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    modal: state.GlobalModal.modals,
  }
}
export default connect(mapStateToProps, { maximizeModal })(ModalTabBar)
